<template>
  <div @wheel="onWheel">
    <slot />
  </div>
</template>

<script setup>
import { useBlokkli } from "#imports";
const { selection } = useBlokkli();
const props = defineProps({
  dragging: { type: Boolean, required: false }
});
function onWheel(e) {
  if (selection.isDragging.value && !props.dragging) {
    e.preventDefault();
    return;
  }
  if (e.ctrlKey || e.metaKey) {
    return;
  }
  e.stopImmediatePropagation();
}
</script>
